export enum SetorTicket {
  Gerencial = 'Gerencial',
  Financeiro = 'Financeiro',
  Academico = 'Academico',
  Comercial = 'Comercial'
}

export enum TipoTicket {
  Informacao = 'Informacao',
  Solicitacao = 'Solicitacao',
  Manifestacao = 'Manifestacao'
}

export enum CategoriaTicket {
  Documentacao = 'Documentacao',
  AtividadesComplementares = 'AtividadesComplementares',
  DocumentacaoResponsavelFinanceiro = 'DocumentacaoResponsavelFinanceiro',
  PrazoNotaTCC = 'PrazoNotaTCC',
  Reingresso = 'Reingresso',
  ServicoFinalizacao = 'ServicoFinalizacao',
  CopiaEmentasDisciplina = 'CopiaEmentasDisciplina',
  ForumDuvidas = 'ForumDuvidas',
  CertificadoImpresso = 'CertificadoImpresso',
  SolicitacaoTCC = 'SolicitacaoTCC',
  DocumentacaoAlunoCertificacao = 'DocumentacaoAlunoCertificacao',
  DocumentacaoProfessorCertificacao = 'DocumentacaoProfessorCertificacao',
  DocumentacaoPPCCertificacao = 'DocumentacaoPPCCertificacao',
  Licenca = 'Licenca'
}

export enum StatusTicket {
  Aberto = 'Aberto',
  Pendente = 'Pendente',
  Finalizado = 'Finalizado'
}

export enum SituacaoEmailSecretaria {
  NaoEnviado = 'NaoEnviado',
  Enviado = 'Enviado',
  Falhou = 'Falhou'
}

export enum SituacaoRequerimento {
  Solicitado = 'Solicitado',
  EmAndamento = 'EmAndamento',
  Concluido = 'Concluido',
  Cancelado = 'Cancelado',
  Aberto = 'Aberto'
}

export enum TipoTicketPorExtenso {
  Informacao = 'Informação',
  Solicitacao = 'Solicitação',
  Manifestacao = 'Manifestação'
}

export enum CategoriaTicketPorExtenso {
  Documentacao = 'Documentação',
  AtividadesComplementares = 'Atividades Complementares',
  DocumentacaoResponsavelFinanceiro = 'Documentação Responsável',
  PrazoNotaTCC = 'Prazo envio nota do TCC',
  Reingresso = 'Reingresso',
  ServicoFinalizacao = 'Serviço Finalização',
  CopiaEmentasDisciplina = 'Ementas de Disciplina',
  ForumDuvidas = 'Forúm de Dúvidas',
  CertificadoImpresso = 'Certificado Impresso',
  SolicitacaoTCC = 'Solicitacão de TCC',
  DocumentacaoAlunoCertificacao = 'Documentação Aluno',
  DocumentacaoProfessorCertificacao = 'Documentação Professor',
  DocumentacaoPPCCertificacao = 'Documentação PPC',
  Licenca = 'Licença'
}

export enum CategoriaTicketParceiroCertificacaoPorExtenso {
  DocumentacaoParceiroCertificacao = 'Documentação PPC',
  DocumentacaoProfessorCertificacao = 'Documentação Professor',
  DocumentacaoAlunoCertificacao = 'Documentação Aluno'
}

export enum SetorTicketPorExtenso {
  Gerencial = 'Gerencial',
  Financeiro = 'Financeiro',
  Academico = 'Acadêmico',
  Comercial = 'Comercial'
}

export enum UsuarioPerfilPorExtenso {
  Aluno = 'Aluno',
  Academico = 'Acadêmico',
  Professor = 'Professor',
  Gerencial = 'Gerencial',
  Financeiro = 'Financeiro',
  Comercial = 'Comercial',
  Parceiro = 'Parceiro'
}
